const injectInfusionTemplates = () => {
  const templates = document.querySelectorAll('template.infusion-template');
  const mobileIndices = [];
  const desktopIndices = [];
  const parent = document.querySelector('#ProductGridContainer ul');

  if (!parent || templates.length === 0) {
    dismissSkeleton();
    return;
  }

  templates.forEach((template) => {
    const sameIndex = template.dataset.sameIndex === 'true';
    let desktopIndex = parseInt(template.dataset.desktopIndex, 10) - 1;
    let mobileIndex = parseInt(template.dataset.mobileIndex, 10) - 1;
    const pageStart = parseInt(template.dataset.startIndex, 10);
    const pageEnd = parseInt(template.dataset.endIndex, 10);

    const desktopInRange = desktopIndex >= pageStart && desktopIndex < pageEnd;
    const mobileInRange = mobileIndex >= pageStart && mobileIndex < pageEnd;
    const children = Array.from(parent.children);

    if (sameIndex && desktopInRange) {
      desktopIndex = calcInsertIndex(desktopIndex, pageStart);
      insertClone(template, parent, children, desktopIndex);
      mobileIndices.push(desktopIndex);
      desktopIndices.push(desktopIndex);
    } else if (!sameIndex && desktopInRange && mobileInRange) {
      mobileIndex = calcInsertIndex(mobileIndex, pageStart, mobileIndices);
      desktopIndex = calcInsertIndex(desktopIndex, pageStart, desktopIndices);
      insertClone(template, parent, children, mobileIndex, 'mobile');
      insertClone(template, parent, children, desktopIndex, 'desktop');
      mobileIndices.push(mobileIndex);
      desktopIndices.push(desktopIndex);
    } else if (!sameIndex && desktopInRange) {
      desktopIndex = calcInsertIndex(desktopIndex, pageStart, desktopIndices);
      insertClone(template, parent, children, desktopIndex, 'desktop');
      desktopIndices.push(desktopIndex);
    } else if (!sameIndex && mobileInRange) {
      mobileIndex = calcInsertIndex(mobileIndex, pageStart, mobileIndices);
      insertClone(template, parent, children, mobileIndex, 'mobile');
      mobileIndices.push(mobileIndex);
    }
  });

  repositionPatternInterruptSlider(parent);
  window.addEventListener('resize', piOnResize, { passive: true });
  dismissSkeleton();
};

/**
 * MORE-113 / MNR-690 — Pattern Interrupt Slider.
 *
 * The slider <li> (.pattern-interrupt-grid-item) should sit after row 2 on desktop
 * (4-col → 8 cells) and after row 4 on mobile (2-col → 8 cells). Content infusion
 * inserts extra <li> cells into the grid, and crucially the mobile-/desktop-only
 * clones occupy a *visible grid cell* at their breakpoint — so they must be COUNTED
 * toward the row position, not skipped.
 *
 * Because the visible cell sequence differs per breakpoint (mobile-only clones show
 * only on mobile, desktop-only only on desktop), we recompute the anchor for the
 * CURRENT breakpoint — counting every cell that is visible at this width — and place
 * the slider after the 8th visible cell. Re-runs on resize.
 */
const PI_TARGET_CELLS = 8; // 4 cols × 2 rows (desktop) = 2 cols × 4 rows (mobile)
const PI_DESKTOP_MQ = '(min-width: 990px)'; // theme --breakpoint-lg; grid goes 4-col here, and lg: infusion clones flip

/** Is this grid cell rendered at the current breakpoint? */
const piIsVisibleAtBreakpoint = (el, isDesktop) => {
  if (el.classList.contains('lg:!hidden')) return !isDesktop; // mobile-only clone
  if (el.classList.contains('lg:!block')) return isDesktop; // desktop-only clone
  return true; // product tiles and "both" infusion items are always visible
};

const repositionPatternInterruptSlider = (parent) => {
  const slider = parent.querySelector(':scope > li.pattern-interrupt-grid-item');
  if (!slider) return;

  const isDesktop = window.matchMedia(PI_DESKTOP_MQ).matches;

  let cellCount = 0;
  let anchor = null; // the 8th visible cell at the current breakpoint

  for (const child of parent.children) {
    if (child === slider) continue;
    if (!piIsVisibleAtBreakpoint(child, isDesktop)) continue;
    cellCount += 1;
    if (cellCount === PI_TARGET_CELLS) {
      anchor = child;
      break;
    }
  }

  // Fewer than 8 visible cells → leave the slider where Liquid placed it.
  if (anchor) anchor.insertAdjacentElement('afterend', slider);
};

// Re-run on breakpoint change so the slider lands after the correct visible row.
let piResizeRaf = null;
const piOnResize = () => {
  if (piResizeRaf) cancelAnimationFrame(piResizeRaf);
  piResizeRaf = requestAnimationFrame(() => {
    const parent = document.querySelector('#ProductGridContainer ul');
    if (parent) repositionPatternInterruptSlider(parent);
  });
};

const calcInsertIndex = (index, pageStart, insertedIndices) => {
  const relative = index === pageStart ? 0 : index - pageStart;
  if (!insertedIndices) return relative;
  return relative + insertedIndices.filter((i) => i < relative).length;
};

const insertClone = (template, parent, children, index, visibility) => {
  const clone = template.content.cloneNode(true);
  if (visibility === 'mobile') {
    clone.querySelector('li').classList.add('block', 'lg:!hidden');
  } else if (visibility === 'desktop') {
    clone.querySelector('li').classList.add('hidden', 'lg:!block');
  }
  parent.insertBefore(clone, children[index] || null);
};

const dismissSkeleton = () => {
  const overlay = document.getElementById('ci-skeleton-overlay');
  if (overlay) {
    overlay.classList.add('hidden');
  }
};

injectInfusionTemplates();
